import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import ModalButtonPanel from "../../shared/components/ModalButtonPanel";
import withModal from "../../shared/components/withModal";
import { services } from "../actions";
import UserGroupToggle from "../components/UserGroupToggle";
import { ProductShape } from "../proptypes";
import selectors from "../selectors";

class AddService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: "",
      serviceName: "",
      description: "",
      username: "",
      groupname: "",
      valid: false
    };
  }

  componentDidMount = () => {
    const { products } = this.props;
    if (products.length > 0) {
      this.setState({ selectedProduct: products[0].$uri });
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    if (name === "serviceName") {
      const pattern = RegExp("^[a-zA-Z][a-zA-Z0-9-_.]{2,20}$");
      this.setState({ valid: pattern.test(value) });
    }
    this.setState({ [name]: value });
  };

  onUpdateUserGroup = newState => {
    this.setState({
      username: newState.username,
      groupname: newState.groupname
    });
  };

  handleSubmit = event => {
    const { addServiceWithAdmin } = this.props;
    const {
      selectedProduct,
      serviceName,
      description,
      username,
      groupname
    } = this.state;
    const service = {
      name: serviceName,
      description,
      product: { $ref: selectedProduct }
    };
    addServiceWithAdmin(service, username, groupname);
    event.preventDefault();
  };

  handleProductSelect = event => {
    this.setState({ selectedProduct: event.target.value });
  };

  render() {
    const { selectedProduct, serviceName, description, valid } = this.state;
    const { products, error, saving, parentUrl } = this.props;
    return (
      <div className="p-modal--add p-card u-no-margin--bottom">
        {error && (
          <div className="p-notification--negative">
            <p className="p-notification__response">
              <span className="p-notification__status">Error:</span>
              {error.description}
            </p>
          </div>
        )}
        <form className="p-form p-form">
          <div className="p-form__group">
            <label htmlFor="add-service-product" className="p-form__label">
              Add a new service
            </label>
            <div className="p-form__control">
              <select
                value={selectedProduct}
                onChange={this.handleProductSelect}
              >
                {products.map(product => (
                  <option key={product.$uri} value={product.$uri}>
                    {product.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="p-form__group">
            <label htmlFor="add-service-name" className="p-form__label">
              Name
            </label>
            <div className="p-form__control">
              <input
                id="add-service-name"
                name="serviceName"
                type="text"
                placeholder="name"
                value={serviceName}
                onChange={this.handleChange}
                maxLength="20"
                required
              />
              <p className="p-form-help-text">Between 3 - 20 characters.</p>
            </div>
          </div>
          <div className="p-form__group">
            <label htmlFor="add-service-description" className="p-form__label">
              Description
            </label>
            <div className="p-form__control">
              <textarea
                id="add-service-description"
                name="description"
                type="text"
                placeholder="description"
                value={description}
                onChange={this.handleChange}
                maxLength="200"
                rows="4"
              />
            </div>
          </div>
          <UserGroupToggle
            heading="Add administrator for this service (optional)"
            tooltip="Administrator role includes permissions for all the scopes of this service"
            onUpdate={this.onUpdateUserGroup}
          />
          <ModalButtonPanel
            parentUrl={parentUrl}
            onSubmit={this.handleSubmit}
            submitButtonTxt="Add Service"
            disabled={!valid}
            inProgress={saving}
          />
        </form>
      </div>
    );
  }
}

AddService.propTypes = {
  parentUrl: PropTypes.string.isRequired,
  addServiceWithAdmin: PropTypes.func.isRequired,
  error: PropTypes.shape({
    description: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired
  }),
  products: PropTypes.arrayOf(ProductShape).isRequired,
  saving: PropTypes.bool
};

AddService.defaultProps = {
  error: undefined,
  saving: false
};

const mapStateToProps = state => ({
  error: selectors.services.getError(state),
  hasServices: selectors.services.getFiltered(state).length !== 0,
  products: selectors.products.getFiltered(state),
  saving: state.services.savingWithAdmin
});

const mapDispatchToProps = {
  addServiceWithAdmin: services.addWithAdmin
};

export default withModal(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddService)
);
